const button = {
    style: {},
    base: 'transition-all duration-300 rounded-md relative outline-none whitespace-nowrap',
    fontSize: {
        default: 'text-xs md:text-sm',
        sm: 'text-sm',
        xs: 'text-xm',
    },
    color: {
        transparent: '',
        default: 'bg-branding-brand-yellow text-black hover:bg-branding-mustard',
        default_pastel: 'bg-branding-smoke text-branding-dark-grey hover:bg-branding-light-grey hover:text-branding-rich-black',
        default_link: 'text-primary hover:text-primary-dark',
        green: 'bg-green-600 text-white hover:bg-green-500',
        green_link: 'text-green-600 hover:text-green-500',
        cool_gray: 'bg-branding-cool-grey text-white  hover:bg-branding-dark-grey',
        branding_green: 'bg-branding-green text-white hover:bg-branding-trustpilot',
        gray: 'bg-branding-smoke text-branding-dark-grey hover:text-black hover:bg-branding-light-grey',
        gray_link: 'text-gray-200 hover:text-gray-300',
        disabled: 'bg-neutral-200 text-gray-400 hover:text-black pointer-events-none',
        white_disabled: 'bg-white border border-[#CACBCF] text-[#CACBCF] ',
        custom_disabled: 'bg-[#CCCCCA] text-white hover:text-black',
        disabled_link: 'text-gray-200 hover:text-gray-300',
        white: 'bg-white text-black hover:bg-neutral-100',
        white_border_only: 'bg-transparent text-white hover:bg-white border border-white hover:text-primary',
        white_border: 'bg-white dark:bg-neutral-800 dark:hover:bg-neutral-600 dark:text-gray-300 text-black hover:bg-neutral-100 border border-branding-mid-grey dark:border-gray-900',
        white_link: 'text-white hover:text-gray-100',
        link: 'text-gray-800 hover:text-black',
        delete: 'bg-red-600 hover:bg-red-800 text-white',
        delete_link: 'text-red-600 hover:text-red-800',
        red: 'bg-red-700 hover:bg-red-600 text-white',
        cancel: 'text-gray-600 hover:text-gray-800 hover:bg-neutral-100',
        warning: 'text-white bg-orange-600 hover:bg-orange-700',
        warning_gray: 'bg-neutral-100 text-gray-800 hover:text-black hover:bg-orange-600 hover:text-white',
    },
    padding: {
        '2xl': 'px-12 py-8',
        xl: 'px-12 py-6',
        lg: 'px-8 py-4',
        none: '',
        normal: 'px-6 py-2 lg:px-8 lg:py-3',
        semi: 'px-6 py-2',
        sm: 'px-6 py-1',
        sm2: 'px-6 py-2',
        sm3: 'px-4 py-2',
        xs: 'px-4 py-1',
    },
    invoice_form_action: 'flex items-center space-x-2 h-[24px] w-[24px] flex items-center justify-center text-sm text-gray-800 transition-all rounded-full hover:bg-primary hover:text-white',
};

for (const color in button.color) {
    // 1. Crée un style de base pour chaque couleur
    button.style[color] = button.base + ' ' + button.color[color] + ' ' + button.padding.normal + ' ' + button.fontSize.default;

    // 2. Crée une variante pour chaque combinaison couleur + padding
    for (const padding in button.padding) {
        button.style[`${color}_${padding}`] = button.base + ' ' + button.color[color] + ' ' + button.padding[padding] + ' ' + button.fontSize.default;
    }
}

// Inbound auth/signup CTA: the yellow pill used across the signup flow + the re-skinned auth pages.
// Single source of truth so every CTA renders via LoadingButton (:class-name="$theme('button.style.inbound')").
button.style.inbound =
    'inbound-cta relative overflow-hidden inline-flex items-center justify-center gap-2 h-cta w-full px-3.5 rounded-cta bg-inbound-yellow border border-inbound-yellow-border shadow-input text-inbound-rich-black font-bricolage font-medium text-base cursor-pointer transition-all hover:bg-inbound-yellow-hover active:bg-inbound-yellow-pressed active:translate-y-px disabled:opacity-40 disabled:cursor-not-allowed';

export default button;
